import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nextPage: '',
  previousPage: '',
};


const appRouteSlice = createSlice({
  name: 'appRoute',
  initialState,
  reducers: {
    setNextPage: (state, action) => {
      state.nextPage = action.payload;
    },
    setPreviousPage: (state, action) => {
      state.previousPage = action.payload;
    },
  },
});

export const {
  setNextPage,
  setPreviousPage,
} = appRouteSlice.actions;

export default appRouteSlice.reducer;